import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'VideoTheaterSlider' */ './VideoTheaterSlider'),
  loading: () => null,
});

export default class WithVideoTheaterSlider extends React.Component {
  render() {
    return <LoadableComponent {...this.props} />;
  }
}
